import { AdminLayout } from "@/components/shared/AdminLayout";
import ChatCenter from "@/components/shared/ChatCenter";

export default function AdminChat() {
  return (
    <AdminLayout title="Communication Center" breadcrumb="Chat">
      <ChatCenter isAdmin={true} />
    </AdminLayout>
  );
}
